import { createAction } from '@reduxjs/toolkit';
import { changeFirewallRequest } from 'pages/Internet/api/requests';
import { ERROR_MESSAGES, SET_FIREWALL_VALUES, SWITCH_FIREWALL_FORM_VISIBLE } from '../../constants';
import { getFTTBFirewallNewLevel } from '../selectors/firewallSelectors';

export const switchFirewallFormVisible = createAction(SWITCH_FIREWALL_FORM_VISIBLE);
export const setFirewallValues = createAction(SET_FIREWALL_VALUES);

export const onFirewallAdditionalClick = () => (dispatch) => {
  dispatch(setFirewallValues({ error: null }));
  dispatch(switchFirewallFormVisible());
};

export const updateFirewall = (level) => (dispatch) => {
  const setFirewallState = (val) => dispatch(setFirewallValues(val));

  setFirewallState({ error: null });

  return changeFirewallRequest({ level: Number(level) })
    .then(({ data }) => data.requestId)
    .then((requestId) => setFirewallState({
      isChecked: !!Number(level),
      futureRequestId: requestId,
    }))
    .catch(() => setFirewallState({
      isChecked: false,
      error: ERROR_MESSAGES.SOMETHING_WENT_WRONG,
    }));
};

export const setNewFirewallLevel = (newLevel) => (dispatch) => {
  dispatch(setFirewallValues({ newFirewallLevel: Number(newLevel) }));
};

export const onUpdateFirewallForm = () => (dispatch, getState) => {
  const level = getFTTBFirewallNewLevel(getState());

  dispatch(updateFirewall(level))
    .then(() => dispatch(switchFirewallFormVisible()));
};
